import {LovValueSummary} from './lovValueSummary.model';
import {AccountSummary} from '../../../../../../shared/model/account/accountSummary.model';
import {WithSummaryModel} from '../../../../entity/dto/plain/withSummary.model';
import {LovListSummary} from '../../../lov-list/api/model/LovListSummary.model';


export class LovValue implements WithSummaryModel<LovValueSummary> {
    summary: LovValueSummary;
    parent: LovValueSummary;
    account: AccountSummary;
    comment: string;
    parentLabel: string;
    lovList: LovListSummary;
}
